import { useState } from 'react';

/** 訂房網折扣碼一筆（可改由後端/KV 或 CMS 提供） */
interface CouponRow {
  platform: string;
  code: string;
  description: string;
  link: string;
}

const MOCK_COUPONS: CouponRow[] = [
  {
    platform: 'Agoda',
    code: 'HOTEL10',
    description: '訂房折抵範例（實際以官網為準）',
    link: 'https://www.agoda.com',
  },
  {
    platform: 'Agoda',
    code: 'VISA85',
    description: '指定卡友優惠',
    link: 'https://www.agoda.com',
  },
  {
    platform: 'Booking.com',
    code: 'TRAVEL15',
    description: '訂房折扣碼範例',
    link: 'https://www.booking.com',
  },
  {
    platform: 'Klook',
    code: 'KLOOKHOTEL',
    description: '住宿專區優惠',
    link: 'https://www.klook.com/zh-TW/hotels/',
  },
];

/**
 * 訂房折扣碼彙整：Agoda、Booking、Klook 當月代碼，一鍵複製與比價
 */
export function HotelCouponListTool() {
  const [copied, setCopied] = useState<string | null>(null);

  const copyCode = (code: string) => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(code);
      setTimeout(() => setCopied(null), 2000);
    });
  };

  return (
    <>
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <p className="mb-4 text-sm text-gray-600 dark:text-gray-400">
          以下為範例折扣碼，實際以各訂房網當月活動為準。建議訂房前搜尋「[訂房網名]
          折扣碼」以取得最新代碼。
        </p>
        <div className="space-y-4">
          {MOCK_COUPONS.map((row, i) => (
            <div
              key={`${row.platform}-${row.code}-${i}`}
              className="flex flex-wrap items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-600 dark:bg-gray-700/50"
            >
              <span className="font-medium text-gray-900 dark:text-gray-100">
                {row.platform}
              </span>
              <code className="rounded bg-white px-2 py-1 font-mono text-sm dark:bg-gray-800">
                {row.code}
              </code>
              <button
                type="button"
                onClick={() => copyCode(row.code)}
                className="rounded border border-gray-300 bg-white px-3 py-1 text-sm hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:hover:bg-gray-600"
              >
                {copied === row.code ? '已複製' : '一鍵複製'}
              </button>
              <span className="w-full text-sm text-gray-600 dark:text-gray-400 sm:w-auto">
                {row.description}
              </span>
              <a
                href={row.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-primary hover:underline"
              >
                前往比價 →
              </a>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
          使用技巧
        </h2>
        <ul className="list-inside list-disc space-y-1 text-sm text-gray-600 dark:text-gray-400">
          <li>結帳前在優惠碼欄位貼上代碼</li>
          <li>部分代碼需搭配指定信用卡或條件</li>
          <li>可多開分頁比較 Agoda / Booking / Klook 同房型價錢</li>
        </ul>
      </div>

      <section className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
          使用說明
        </h2>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          彙整 Agoda、Booking.com、Klook
          等訂房網當月可用折扣碼，一鍵複製後至官網結帳使用。本頁可改為由後端或
          CMS 定期更新，並可加入「各國房價參考」等進階功能以提升回訪率。
        </p>
      </section>
    </>
  );
}
